"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _elements = require("@superlogica/foundation/elements");

var _tokens = require("@superlogica/foundation/tokens/");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Container = _styledComponents.default.div.withConfig({
  componentId: "sc-1ptnhkg-0"
})(["", ""], function (_ref) {
  var background = _ref.background,
      border = _ref.border,
      borderColor = _ref.borderColor,
      paddingType = _ref.paddingType,
      paddingSize = _ref.paddingSize,
      radius = _ref.radius;
  return "\n    border: ".concat(border ? _tokens.borderWidth.xs + "px solid " + _tokens.colors[borderColor.color + borderColor.scale] : "none", ";\n    background: ").concat(_tokens.colors[background], ";\n    padding-top: ").concat(_elements.boxPadding[paddingType][paddingSize].top, "px;\n    padding-right: ").concat(_elements.boxPadding[paddingType][paddingSize].right, "px;\n    padding-bottom: ").concat(_elements.boxPadding[paddingType][paddingSize].bottom, "px;\n    padding-left: ").concat(_elements.boxPadding[paddingType][paddingSize].left, "px;\n    border-radius: ").concat(_tokens.borderRadius[radius], "px;\n  ");
});

exports.Container = Container;